export const qualifying_level_permission = {
    required_permission: ['view_ratingscale', 'add_ratingscale', 'change_ratingscale', 'delete_ratingscale', "view_qualifyinglevel"]
}